import { useQuery } from "@tanstack/react-query";

import { getReportingPartners } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import type { ReportingPeriod } from "Reporting/Components/PeriodSelector";
import { REPORTING_QUERY_KEYS } from "./queryKeys";

export function useReportingPartnersQuery(period?: ReportingPeriod) {
  return useQuery({
    queryKey: [...REPORTING_QUERY_KEYS.partners(), period ?? "all"],
    queryFn: processResponse(() => getReportingPartners()),
    staleTime: 5 * 60 * 1000,
  });
}
